import actions from './actions';
import LfDataService from '../../../Services/LfDataService';

import {
    pageIsLoadingAction, 
    pageLoadedAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';

/*

memberAnimals
MemberAnimals
*/

export function fetchCustomerAnimals() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        let animals; 

        dispatch(setCustomerAnimalsFetching(true));

        lfDataService.customerAnimals()
            .then(data => {
                animals = data.animals;

                dispatch(setCustomerAnimals(animals));
                dispatch(setCustomerAnimalsFetching(false));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}

export function setCustomerAnimalsFetching(data) {
    return {
        type: actions.CUSTOMER_ANIMALS_FETCHING_SET,
        payload: data
    };
}
export function setCustomerAnimals(data) {
    return {
        type: actions.CUSTOMER_ANIMALS_SET,
        payload: data
    };
}